import { render, staticRenderFns } from "./CercaIndirizzoSearchItem.vue?vue&type=template&id=6de806eb&"
import script from "./CercaIndirizzoSearchItem.vue?vue&type=script&lang=js&"
export * from "./CercaIndirizzoSearchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports